import React from 'react';
import { Icon, textareaToPlainText } from '../';

export const formatSelectOptions = ({
  options,
  optionValue,
  optionLabel,
  optionSecondaryLabel,
  optionIcon,
  optionPhoto,
  defaultOption,
  optionDisabled,
  optionEnabled,
  tooltip,
  className,
}) => {
  let arr = defaultOption !== undefined ? [defaultOption] : [];

  options.forEach(item => {
    let tmp = {
      ...item,
      value: item[optionValue],
      label: item[optionLabel],
      secondaryLabel: item[optionSecondaryLabel],
    };
    if (optionIcon) {
      tmp = { ...tmp, icon: item[optionIcon] };
    }
    if (optionPhoto) {
      tmp = { ...tmp, photo: item[optionPhoto] };
    }
    if (optionDisabled) {
      tmp = { ...tmp, disabled: item[optionDisabled] };
    }
    // The counterpart, for a source that states the positive. Reading a property called
    // "..._is_disabled" to decide whether to disable is one negation; naming the property for what
    // is true of the thing, and inverting here, is none.
    if (optionEnabled) {
      tmp = { ...tmp, disabled: !item[optionEnabled] };
    }
    if (tooltip) {
      tmp = { ...tmp, tooltip: textareaToPlainText(item[tooltip]) };
    }
    if (className) {
      tmp = { ...tmp, className: item[className] };
    }
    arr.push(tmp);
  });

  return arr;
};

export const formatOptionTooltip = option => {
  if (!option) return '';

  let title =
    option.icon && option.label ? (
      <React.Fragment>
        <Icon name={option.icon} />
        {option.label}
      </React.Fragment>
    ) : (
      option.label
    );
  let subTitle = option.secondaryLabel;
  let bodyText =
    option.tooltip && option.icon && !option.label ? (
      <React.Fragment>
        <Icon name={option.icon} />
        {option.tooltip}
      </React.Fragment>
    ) : (
      option.tooltip
    );

  return { title, subTitle, bodyText };
};
